/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConfiguredActionItemDto } from './configuredActionItemDto';
import { BuildingEquipmentItemDto } from './buildingEquipmentItemDto';
import { AssessmentPresetItemDto } from './assessmentPresetItemDto';
import { CheckpointItemDto } from './checkpointItemDto';
import { AttachmentDetailDto } from './attachmentDetailDto';
import { InspectionEntryCommentDto } from './inspectionEntryCommentDto';
import { BuildingSectionItemDto } from './buildingSectionItemDto';


export interface InspectionEntryDetailDto { 
    id: string;
    note: string;
    deadline?: InspectionEntryDetailDto.DeadlineEnum;
    action?: ConfiguredActionItemDto;
    occurrenceProbability: InspectionEntryDetailDto.OccurrenceProbabilityEnum;
    damageExtent: InspectionEntryDetailDto.DamageExtentEnum;
    markedForPostProcessing: boolean;
    predefinedAssessment?: AssessmentPresetItemDto;
    checkpoint: CheckpointItemDto;
    attachments: Array<AttachmentDetailDto>;
    buildingSection: BuildingSectionItemDto;
    appliedFromPreviousInspection: boolean;
    buildingEquipments: Array<BuildingEquipmentItemDto>;
    repairTaskId?: string;
    comments: Array<InspectionEntryCommentDto>;
    clientId?: string;
}
export namespace InspectionEntryDetailDto {
    export type DeadlineEnum = 'YEAR' | 'HALF_YEAR' | 'ONE_MONTH' | 'NONE' | 'TEN_DAYS';
    export const DeadlineEnum = {
        Year: 'YEAR' as DeadlineEnum,
        HalfYear: 'HALF_YEAR' as DeadlineEnum,
        OneMonth: 'ONE_MONTH' as DeadlineEnum,
        None: 'NONE' as DeadlineEnum,
        TenDays: 'TEN_DAYS' as DeadlineEnum
    };
    export type OccurrenceProbabilityEnum = 'NO_FINDING' | 'VERY_LOW' | 'LOW' | 'MEDIUM' | 'HIGH';
    export const OccurrenceProbabilityEnum = {
        NoFinding: 'NO_FINDING' as OccurrenceProbabilityEnum,
        VeryLow: 'VERY_LOW' as OccurrenceProbabilityEnum,
        Low: 'LOW' as OccurrenceProbabilityEnum,
        Medium: 'MEDIUM' as OccurrenceProbabilityEnum,
        High: 'HIGH' as OccurrenceProbabilityEnum
    };
    export type DamageExtentEnum = 'NO_FINDING' | 'VERY_LOW' | 'LOW' | 'MEDIUM' | 'HIGH';
    export const DamageExtentEnum = {
        NoFinding: 'NO_FINDING' as DamageExtentEnum,
        VeryLow: 'VERY_LOW' as DamageExtentEnum,
        Low: 'LOW' as DamageExtentEnum,
        Medium: 'MEDIUM' as DamageExtentEnum,
        High: 'HIGH' as DamageExtentEnum
    };
}


